// React Libraries
import React, { Fragment } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Link } from 'react-router-dom';

// Ant Design
import { notification, Popconfirm } from 'antd';

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUnlock, faLock } from '@fortawesome/free-solid-svg-icons';

// UI Libraries
import H3Text from '@Uilib/h3Text';

// Constants
import Constants, { entityNameEnum } from '@Apis/constants';
import Helpers from '@Apis/helpers';

// Ant Design
import { Menu } from 'antd';

export const INITIAL_STATE = {
  isUserReady: false,
  isUserReadyForPrefillData: false,
  currentUpdate: '',
  isGetAttachment: false,
  showConvertToMo: false,
  showConvertToPr: false,
  showDCDrawer: false,
  currentTab: '/sales-order-lines',
  showReservationDrawer: false,
  showUpdateReservationDrawer: false,
  showNewSalesForm: false,
  showNewPackingSlipForm: false,
  visibleColumns: {
    SKU: {
      label: 'SKU#',
      visible: true,
      disabled: true,
    },
    QTY: {
      label: 'Quantity',
      visible: true,
      disabled: true,
    },
    PRICE: {
      label: 'Price',
      visible: true,
      disabled: true,
    },
    TAX: {
      label: 'TAX',
      visible: true,
      disabled: true,
    },
    DISCOUNT: {
      label: 'Discount',
      visible: true,
      disabled: true,
    },
    TOTAL: {
      label: 'Total',
      visible: true,
      disabled: true,
    },
  },
  documentUINames: {
    uiName: '',
    shortUIName: '',
    salesOrderUIName: '',
    salesOrderShortUIName: '',
    estimateUIName: '',
    estimateShortUIName: '',
    amcSalesOrderUIName: '',
    amcSalesOrderShortUIName: '',
  },
};

export const handleFileChangeHelper = ({
  fileListData, props, updateState
}) => {

  const { updateAttachment, selectedSO, getAttachmentById } = props;

  const fileList = fileListData?.fileList?.map((item) => ({
    ...item,
    url: item?.response?.response?.location || item?.url,
  }));

  const attachments = fileList?.map((attachment) => ({
    url: attachment?.response?.response?.location || attachment?.url, type: attachment.type, name: attachment.name, uid: attachment.uid,
  }));

  if (fileListData?.file.status === 'done') {
    const payload = {
      entity_id: selectedSO?.order_id,
      entity_name: 'sales_order',
      attachments,
    };
    updateAttachment(payload, () => {
      getAttachmentById(selectedSO?.order_id, 'sales_order', () => {
        updateState({
          isGetAttachment: true,
        });
      });
    });
  }
  if (fileListData?.file.status === 'removed') {
    const payload = {
      entity_id: selectedSO?.order_id,
      entity_name: 'sales_order',
      attachments,
    };
    updateAttachment(payload, () => {
      getAttachmentById(selectedSO?.order_id, 'sales_order', () => {
        updateState({
          isGetAttachment: true,
        });
      });
    });
  }

  updateState({
    fileList: attachments.length > 0 ? attachments : [],
  });
};

export const handleDrawerStateHelper = ({
  type, value1, value2, value3, value4, updateState
}) => {

  if (type === 'CHANGE_LOCATION') {
    updateState({
      isShowDrawerForChangeLocation: true, shopifyLocationId: value1, fulfillmentId: value2, productSkuTenantIdMapping: value3, tenantId: value4,
    });
  }
  if (type === 'CREATE_FULFILLMENT') {
    updateState({ isShowDrawerForCreateFulfillment: true, shopifyLocationId: value1, fulfillmentId: value2 });
  }
  if (type === 'RETURN') {
    updateState({ isShowDrawerForReturn: true, selectedFulfillment: value1 });
  }
  if (type === 'REFUND') {
    updateState({ isShowDrawerForRefund: true, selectedReturn: value1 });
  }
};

export const tenantIdProductMapping = (productSkuTenantIdMapping, products) => {

  const uniqueProductSkuIds = [...new Set(Object.keys(productSkuTenantIdMapping || {}))];

  const tenantIdProductSkuIdsMap = new Map();

  for (const productSku in productSkuTenantIdMapping) {
    const entries = productSkuTenantIdMapping[productSku];
    for (const entry of entries) {
      if (!tenantIdProductSkuIdsMap.has(entry?.tenant_id)) {
        tenantIdProductSkuIdsMap.set(entry?.tenant_id, []);
      }
      tenantIdProductSkuIdsMap.get(entry?.tenant_id).push(productSku);
    }
  }

  const tenantIdProductMapping = {};

  for (const [tenantId, skuIds] of tenantIdProductSkuIdsMap.entries()) {
    const obj = {};
    if (skuIds?.length) {
      const availableProducts = [];
      const unavailableProducts = [];

      for (let i = 0; i < skuIds?.length; i++) {
        availableProducts.push(products?.find((product) => product?.product_sku_info?.product_sku_id == skuIds[i])?.product_sku_info);
      }

      for (let i = 0; i < uniqueProductSkuIds.length; i++) {
        if (!skuIds.includes(uniqueProductSkuIds[i])) {
          unavailableProducts.push(products?.find((product) => product?.product_sku_info?.product_sku_id == uniqueProductSkuIds[i])?.product_sku_info);
        }
      }
      obj.availableProducts = availableProducts;
      obj.unavailableProducts = unavailableProducts;
    }
    tenantIdProductMapping[tenantId] = obj;
  }
  return tenantIdProductMapping;
};

export const renderFreightHelper = ({
  position, props
}) => {

  const { selectedSO, MONEY } = props;
  if ((selectedSO?.charge_1_value > 0)) {
    if (position === 'top' && selectedSO?.freight_tax_id) {
      return (
        <div className="view-document__totals-field">
          <H3Text
            text={(
              <Fragment>
                {selectedSO?.charge_1_name}
                &nbsp;
                <span className="table-subscript">{`tax@${selectedSO?.freight_tax_info?.tax_value}%`}</span>
              </Fragment>
            )}
            className="view-document__totals-field-name"
          />
          <H3Text text={MONEY((selectedSO?.charge_1_value || 0), selectedSO?.org_currency_info?.currency_code)} className="view-document__totals-field-value" />
        </div>
      );
    }
    if (position === 'bottom' && !selectedSO?.freight_tax_id) {
      return (
        <div className="view-document__totals-field">
          <H3Text text={selectedSO?.charge_1_name} className="view-document__totals-field-name" />
          <H3Text
            text={MONEY((selectedSO?.charge_1_value), selectedSO?.org_currency_info?.currency_code)}
            className="view-document__totals-field-value"
          />
        </div>
      );
    }
  }
  return '';
};

export const getShopifyStatusProps = (status) => {
  if (status === 'fulfilled') return { bgColor: '#2fbc6e' };
  if (status === 'pending') return { bgColor: '#ababab' };
  if (status === 'restocked') return { bgColor: '#e8c62a' };
  if (status === 'partial') return { bgColor: '#ef842c' };
  return { bgColor: '#335aa8' };
};

export const HideAdhocApprovalsHelper = ({
  props
}) => {

  const { selectedSO } = props;

  if (selectedSO?.workflow_steps) {
    const steps = Object.values(selectedSO?.workflow_steps)?.filter((step) => step !== null);
    const pendingSteps = steps?.filter((step) => step?.status === 'PENDING');
    return steps.length < 10 && pendingSteps.length === steps.length;
  }
  return false;
};

export const splitChargesData = (charge) => {
  const chargeWithTaxName = charge?.filter((line) => line?.tax_info?.tax_id) || [];
  const chargeWithoutTaxName = charge?.filter((line) => !line?.tax_info?.tax_id) || [];
  return { chargeWithTaxName, chargeWithoutTaxName };
};

export const renderChargesHelper = ({
  charge, props
}) => !!charge?.length && charge?.map((otherCharge, i) => {

  const { selectedSO, MONEY } = props;

  return (
    <div key={i} className="view-document__totals-field">
      <H3Text
        text={(
          <Fragment>
            {otherCharge?.charge_name?.toProperCase()}&nbsp;
            {otherCharge?.tax_info?.tax_value ? (
              <span className="table-subscript">{`tax@${otherCharge.tax_info.tax_value}%`}</span>
            ) : null}
          </Fragment>
        )}
        className="view-document__totals-field-name" />
      <H3Text text={MONEY((otherCharge?.charge_amount), selectedSO?.org_currency_info?.currency_code)} className="view-document__totals-field-value" />
    </div>
  );
});

export const getTotalQuantity = (salesOrderLines) => salesOrderLines?.reduce((acc, line) => acc + line?.quantity, 0);

export const menuHelper = ({
  props, state
}) => {
  const { selectedSO, downloadDocument } = props;

  const { documentUINames } = state;

  return (
    <Menu>
      {selectedSO?.org_currency_info?.org_currency_id && (
        <Menu.Item>
          <H3Text
            // text={`${isEstimate ? 'Estimate' : 'Sales Order'} (${selectedSO?.org_currency_info?.currency_code})`}
            text={`${documentUINames.uiName} (${selectedSO?.org_currency_info?.currency_code})`}
            onClick={() => downloadDocument({
              url: `${Constants.SO}/download?order_id=${selectedSO?.order_id}&download_document_in_base_currency=false`,
              // document_type: isEstimate ? "ESTIMATE" : 'SALES_ORDER',
              document_type: documentUINames.uiName.toUpperCase().replaceAll(' ', '_'),
              document_number: selectedSO?.sales_order_number,
              key: uuidv4(),
            })}
            className="hide__in-mobile"
          />
        </Menu.Item>
      )}
      {(selectedSO?.base_currency_info?.org_currency_id && selectedSO?.org_currency_info?.org_currency_id !== selectedSO?.base_currency_info?.org_currency_id) && (
        <Menu.Item>
          <H3Text
            // text={`${isEstimate ? 'Estimate' : 'Sales Order'} (${selectedSO?.base_currency_info?.currency_code})`}
            text={`${documentUINames.uiName} (${selectedSO?.base_currency_info?.currency_code})`}
            onClick={() => downloadDocument({
              url: `${Constants.SO}/download?order_id=${selectedSO?.order_id}&download_document_in_base_currency=true`,
              // document_type: isEstimate ? "ESTIMATE" : 'SALES_ORDER',
              document_type: documentUINames.uiName.toUpperCase().replaceAll(' ', '_'),
              document_number: selectedSO?.sales_order_number,
              key: uuidv4(),
            })}
            className="hide__in-mobile"
          />
        </Menu.Item>
      )}
    </Menu>
  );
};
export const addAlpha = (color, opacity) => {
  // coerce values so ti is between 0 and 1.
  const _opacity = Math.round(Math.min(Math.max(opacity || 1, 0), 1) * 255);
  return color + _opacity.toString(16).toUpperCase();
};

export const getLinkedDocumentInfoHelper = ({ props, state }) => {

  const {
    selectedSO, user, priceMasking, unLinkMOFromSo, getSOById, history
  } = props;

  const {
    documentUINames, currentTenantId, currentOrderId, salesOrderType
  } = state;

  const { isDataMaskingPolicyEnable, isHideCostPrice } = priceMasking;

  let linkedDocumentsInfo = [];

  if (selectedSO?.sales_orders?.length > 0) {

    let documentDataInfo = [];

    selectedSO?.sales_orders?.forEach((item) => {

      documentDataInfo.push({
        documentId: item?.order_id,
        documentNumber: item?.sales_order_number,
        documentStatus: item?.status,
        documentTotal: item?.order_grand_total,
      });
    });

    const soDataInfo = {
      entityName: entityNameEnum.SALES_ORDER,
      entityVisible: Helpers.getPermission(Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ, user) && selectedSO?.custom_status_info?.type === 'CONFIRMED',
      title: `${documentUINames.salesOrderUIName.toUpperCase()}`,
      entityNumberPrefix: '',
      documentData: documentDataInfo,
      isRedirect: true,
      redirectPath: '/sales/sales-order/view/',
      hidePrice: isDataMaskingPolicyEnable && isHideCostPrice,
      popOverMessage: "You don't have access to view amount",
      showEntityTotal: true,
    };

    linkedDocumentsInfo.push(soDataInfo);
  }

  if (selectedSO?.so_linked_packing_slips?.length > 0) {

    let documentDataInfo = [];

    selectedSO?.so_linked_packing_slips?.forEach((item) => {

      documentDataInfo.push({
        documentId: item?.order_id,
        documentNumber: item?.sales_order_number,
        documentStatus: item?.status,
      });
    });

    const psDataInfo = {
      entityName: entityNameEnum.PACKING_SLIP,
      entityVisible: Helpers.getPermission(Helpers.permissionEntities.PACKING_SLIP, Helpers.permissionTypes.READ, user),
      title: 'PACKING SLIPS',
      entityNumberPrefix: '',
      documentData: documentDataInfo,
      isRedirect: true,
      redirectPath: '/sales/packing-slip/view/',
      showEntityTotal: false,
    };

    linkedDocumentsInfo.push(psDataInfo);
  }

  if (selectedSO?.invoices?.length > 0) {

    let documentDataInfo = [];

    selectedSO?.invoices?.forEach((item) => {

      documentDataInfo.push({
        documentId: item?.invoice_id,
        documentNumber: item?.invoice_number,
        documentStatus: item?.status,
        documentTotal: item?.invoice_grand_total,
      });
    });

    const invoiceDataInfo = {
      entityName: entityNameEnum.INVOICES,
      entityVisible: Helpers.getPermission(Helpers.permissionEntities.INVOICE, Helpers.permissionTypes.READ, user) && selectedSO?.custom_status_info?.type === 'CONFIRMED',
      title: selectedSO?.order_type === 'ANNUAL_MAINTENANCE_CONTRACT' ? "Consumption Orders" : "INVOICES",
      entityNumberPrefix: '',
      documentData: documentDataInfo,
      isRedirect: true,
      redirectPath: selectedSO?.order_type === 'ANNUAL_MAINTENANCE_CONTRACT' ? '/sales/consumption/view/' : '/sales/invoice/view/',
      hidePrice: isDataMaskingPolicyEnable && isHideCostPrice,
      popOverMessage: "You don't have access to view amount",
      showEntityTotal: selectedSO?.order_type !== 'ANNUAL_MAINTENANCE_CONTRACT',
    };

    linkedDocumentsInfo.push(invoiceDataInfo);
  }

  if (selectedSO?.reference_dc?.length > 0) {

    let documentDataInfo = [];

    selectedSO?.reference_dc?.forEach((item) => {

      documentDataInfo.push({
        documentId: item?.delivery_challan_id,
        documentNumber: item?.dc_number,
        documentStatus: item?.status,
      });
    });

    const dcDataInfo = {
      entityName: entityNameEnum.DELIVERY_CHALLAN,
      entityVisible: Helpers.getPermission(Helpers.permissionEntities.DELIVERY_CHALLAN, Helpers.permissionTypes.READ, user),
      title: 'DELIVERY CHALLANS',
      entityNumberPrefix: '',
      documentData: documentDataInfo,
      isRedirect: true,
      redirectPath: '/inventory/delivery-challan/view/',
      showEntityTotal: false,
    };

    linkedDocumentsInfo.push(dcDataInfo);
  }

  if (selectedSO?.linked_prs?.length > 0) {

    let documentDataInfo = [];

    selectedSO?.linked_prs?.forEach((item) => {

      documentDataInfo.push({
        documentId: item?.purchase_requisition_id,
        documentNumber: item?.pr_number,
        documentStatus: item?.status,
      });
    });

    const prDatainfo = {
      entityName: entityNameEnum.PURCHASE_REQUEST,
      entityVisible: Helpers.getPermission(Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ, user),
      title: 'MATERIAL REQUEST',
      entityNumberPrefix: '',
      documentData: documentDataInfo,
      isRedirect: true,
      redirectPath: '/purchase/purchase-request/view/',
      showEntityTotal: false,
    };

    linkedDocumentsInfo.push(prDatainfo);
  }

  if (selectedSO?.linked_mo?.length > 0) {

    let documentDataInfo = [];

    selectedSO?.linked_mo?.forEach((item) => {

      documentDataInfo.push({
        documentId: item?.mo_id,
        documentNumber: item?.mo_number,
        documentStatus: item?.status,
        documentCustomCallback: () => {
          if (((item?.mo_users?.length > 0) && item?.mo_users.includes(user?.user_id)) || (item?.mo_users === null)) {
            history.push(`/production/manufacturing-orders/view/${item?.mo_id}`);
          } else {
            notification.error({
              message: 'Sorry, you don\'t have permission to access this manufacturing order.',
              placement: 'top',
              duration: 4,
            });
          }
        },
        documentCustomAddOn: () => (
          <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }} onClick={(e) => e.stopPropagation()}>
            <Popconfirm
              title="Are you sure you want to unlink this MO?"
              onConfirm={() => unLinkMOFromSo({
                mo_id: item?.mo_id,
                so_id: selectedSO?.so_id,
              }, () => {
                const payload = {
                  orgId: user?.tenant_info?.org_id,
                  tenantId: currentTenantId,
                  soId: currentOrderId,
                  orderType: salesOrderType,
                };
                getSOById(payload);
                // getSOById(user?.tenant_info?.org_id, currentTenantId, currentOrderId);
              })}
              okText="Yes"
              cancelText="No"
              placement="topRight"
              disabled={((item?.mo_users?.length > 0) && !item?.mo_users.includes(user?.user_id))}
            >
              <div
                style={{
                  marginLeft: 'auto',
                  marginRight: '10px',
                  cursor: 'pointer',
                  display: 'inline-block',
                  marginTop: '8px',
                }}
              >
                <Link>
                  Unlink MO
                </Link>
              </div>
            </Popconfirm>
            {(((item?.mo_users?.length > 0) && item?.mo_users.includes(user?.user_id)) || (item?.mo_users === null)) ? (
              <div className="so-invoice__unlock">
                <FontAwesomeIcon icon={faUnlock} style={{ fontSize: '16px', width: '35px', textAlign: 'center' }} />
              </div>
            ) : (
              <div className="so-invoice__lock">
                <FontAwesomeIcon icon={faLock} style={{ fontSize: '16px', width: '35px', textAlign: 'center' }} />
              </div>
            )}
          </div>
        ),
      });
    });

    const moDataInfo = {
      entityName: entityNameEnum.MANUFACTURING_ORDER,
      entityVisible: Helpers.getPermission(Helpers.permissionEntities.MO, Helpers.permissionTypes.READ, user),
      title: 'MANUFACTURING ORDERS',
      entityNumberPrefix: '',
      documentData: documentDataInfo,
      hasCustomCallback: true,
      showEntityTotal: false,
    };

    linkedDocumentsInfo.push(moDataInfo);
  }

  return linkedDocumentsInfo;
};